import React from "react";

function TopBanner(props) {
  return (
    <div className="relative flex items-center justify-center">
      <div className="absolute inset-0 bg-w-bg"></div>

      <h1 className="relative text-2xl text-center md:text-4xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-gray-200 to-gray-900 animate-bg">
        {props.text}
      </h1>
    </div>
  );
}

export default TopBanner;
